import {Component, ViewChild} from '@angular/core';
import {DialogPopupComponent} from '../dialog-popup/dialog-popup.component';
import {
  ResetStartPageConfirmationDialogComponent
} from "../reset-start-page-confirmation-dialog/reset-start-page-confirmation-dialog.component";

@Component({
  selector: 'reset-startpage-popup',
  imports: [DialogPopupComponent, ResetStartPageConfirmationDialogComponent],
  templateUrl: './reset-start-page-popup.component.html',
  standalone: true,
  styleUrl: './reset-start-page-popup.component.scss'
})
export class ResetStartPagePopupComponent {
  @ViewChild('dialog') dialogPopupComponent!: DialogPopupComponent;

  @ViewChild(ResetStartPageConfirmationDialogComponent)
  confirmationDialogComponent!: ResetStartPageConfirmationDialogComponent;


  public static instance: ResetStartPagePopupComponent;

  constructor() {
    ResetStartPagePopupComponent.instance = this;
  }

  openDialog(): void {
    this.dialogPopupComponent.openDialog();
  }

  openConfirmationDialogPopup(): void {
    this.dialogPopupComponent.closeDialog();

    setTimeout(() =>
      {
        this.confirmationDialogComponent.openDialog();
      },
      300
    );
  }
}
